/* DB_SIZE_LABELS_V2 (Dessert Boutique) - adds "+ decorations" where the old YMQ text had it
   Shopify variant values look like "Średni (2 kg, 10-12 osób)".
   On the product page (variants drawn by the YMQ app) show only "Średni" on the buttons and in the
   selected-value text, and put "2 kg, 10-12 osób" in one line under the buttons.
   Input values are not changed, so variant selection, cart and prices work as before. */
(function () {
  if (window.__dbSizeLabels) return;
  window.__dbSizeLabels = true;

  var RE = /^(.+?)\s*\((.+)\)\s*$/;
  // sizes that had "cake + decorations" in the old YMQ text (S = small, M = medium, B = big)
  var DECO = {"cake-potatoes":"SMB","classic-happy-birthday-cake":"SMB","colorful-pastel-retro-birthday-cake":"SMB","custom-edible-photo-print-birthday-cake":"SMB","duck-and-bees-gender-reveal-cake":"SMB","duck-birthday-cake":"SMB","funny-friends-tv-show-theme-birthday-cake":"SMB","gym-fitness-barbells-and-kettlebells-cake":"SMB","heart-shaped-jewel-vintage-birthday-cake":"SMB","japanese-sushi-boat-theme-cake":"SMB","ocean-cruise-liner-cake":"SMB","panda-bamboo-birthday-cake":"SMB","pastel-yellow-cake-with-buttercream-flowers":"SMB","pink-birthday-cake-with-silver-tiara":"SMB","pink-teddy-bear-and-daisies-cake":"SMB","sage-green-lambeth-vintage-ribbon-cake":"SMB","teal-retro-birthday-cake-with-cream-piping":"SMB","textured-white-birthday-cake":"SMB","two-tier-yellow-gingham-duck-cake":"SMB","unicorn-theme-birthday-cake":"SMB","vintage-two-tier-wedding-lambeth-cake":"SMB","white-birthday-cake-with-wafer-paper-and-roses":"SMB","red-heart-birthday-cake":"MB","green-and-white-watercolor-birthday-cake":"SB","modern-wedding-cake-with-funko-pop-toppers":"MB"};
  var SIZE_KEY = { small: 'S', 'mały': 'S', 'малий': 'S', medium: 'M', 'średni': 'M', 'середній': 'M', big: 'B', 'duży': 'B', 'великий': 'B' };
  var DECO_WORD = { pl: ' + dekoracje', uk: ' + декор', en: ' + decorations' };
  function handle() { var m = /\/products\/([^\/?#]+)/.exec(location.pathname); return m ? decodeURIComponent(m[1]) : ''; }
  function withDeco(shortName, info) {
    var sizes = DECO[handle()];
    var key = SIZE_KEY[String(shortName).trim().toLowerCase()];
    if (!sizes || !key || sizes.indexOf(key) === -1 || !info) return info;
    var lang = (document.documentElement.lang || 'pl').slice(0, 2).toLowerCase();
    var word = DECO_WORD[lang] || DECO_WORD.pl;
    var i = info.indexOf(', ');
    return i === -1 ? info + word : info.slice(0, i) + word + info.slice(i);
  }
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }
  function compact(s) { return String(s || '').replace(/\s+/g, ''); }
  function shortOf(v) { var m = RE.exec(norm(v)); return m ? m[1] : v; }
  function infoOf(v) { var m = RE.exec(norm(v)); return m ? m[2] : ''; }

  function replaceText(root, full, rep, skip) {
    var changed = false;
    var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = tw.nextNode())) {
      if (skip && skip.contains(n)) continue;
      if (n.nodeValue.indexOf(full) !== -1) { n.nodeValue = n.nodeValue.split(full).join(rep); changed = true; }
    }
    return changed;
  }

  function fixLabel(label, full, rep) {
    if (replaceText(label, full, rep)) return;
    // value may be split into several text nodes (e.g. with <br>)
    if (compact(label.textContent).indexOf(compact(full)) === -1) return;
    var best = null;
    label.querySelectorAll('*').forEach(function (el) {
      if (el.tagName === 'INPUT' || el.tagName === 'svg' || el.closest('svg')) return;
      var onlyText = Array.prototype.every.call(el.children, function (c) { return c.tagName === 'BR'; });
      if (onlyText && compact(el.textContent) === compact(full)) best = el;
    });
    if (best) best.textContent = rep;
  }

  function run() {
    var groups = {};
    document.querySelectorAll('input.ymq-shopify-option[type="radio"]').forEach(function (i) {
      (groups[i.name] = groups[i.name] || []).push(i);
    });
    Object.keys(groups).forEach(function (name) {
      var inputs = groups[name];
      if (!inputs.every(function (i) { return RE.test(norm(i.value)); })) return;
      inputs.forEach(function (i) {
        var label = i.closest('label') || i.parentElement;
        if (label) fixLabel(label, norm(i.value), shortOf(i.value));
      });
      var checked = inputs.filter(function (i) { return i.checked; })[0] || inputs[0];
      var items = inputs[0].closest('.ymq-option-value-items') || inputs[0].parentElement;
      var box = items && items.parentElement;
      if (!box) return;
      // selected-value text next to the option title
      inputs.forEach(function (i) { replaceText(box, norm(i.value), shortOf(i.value), items); });
      var line = box.querySelector('.db-size-info');
      if (!line) {
        line = document.createElement('div');
        line.className = 'db-size-info';
        items.insertAdjacentElement('afterend', line);
      }
      var txt = withDeco(shortOf(checked.value), infoOf(checked.value));
      if (line.textContent !== txt) line.textContent = txt;
      line.hidden = !txt;
    });
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 30); }
  document.addEventListener('change', schedule, true);
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  schedule();
})();
